import config from "@/config";
import http from "@/utils/request";

export default {
	studyLevelConfig: {
		list: {
			url: `${config.API_URL}/admin/study_level_config/getList`,
			name: "获取等级配置列表",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		all: {
			url: `${config.API_URL}/admin/study_level_config/getAll`,
			name: "获取全部等级配置",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/study_level_config/getDetail`,
			name: "获取等级配置详情",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		create: {
			url: `${config.API_URL}/admin/study_level_config/create`,
			name: "创建等级配置",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		update: {
			url: `${config.API_URL}/admin/study_level_config/update`,
			name: "更新等级配置",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/study_level_config/delete`,
			name: "删除等级配置",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
	collegeConfig: {
		get: {
			url: `${config.API_URL}/admin/study_level_config/getCollegeConfig`,
			name: "获取商学院配置",
			get: async function (params = {}) {
				return await http.get(this.url, params);
			},
		},
		set: {
			url: `${config.API_URL}/admin/study_level_config/setCollegeConfig`,
			name: "设置商学院配置",
			post: async function (data = {}) {
				return await http.post(this.url, data);
			},
		},
	},
};
